import sidebar from '@/config/sidebars/admin_hubspot'
import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminHubspotQuotes = {
  index: async(props) => {
    const { default: QuotesIndex } = await import('@/vue_widgets/admin/hubspot/quotes/index.vue')
    createVueApp(QuotesIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: QuotesShow } = await import('@/vue_widgets/admin/hubspot/quotes/show.vue')
    createVueApp(QuotesShow, { props, sidebar })
  }
}
